var _circle, _circle2, _circle3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgNoticeEmail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 151,
    viewBox: "0 0 154 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 77,
    cy: 75.5,
    r: 70,
    stroke: "#FFD4D6",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.34,
    cx: 77,
    cy: 75.5,
    r: 75,
    stroke: "#FFD4D6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 75.5,
    r: 63.5,
    stroke: "#FFD4D6",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5848_117409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 75C16.5 41.8629 43.3629 15 76.5 15C109.637 15 136.5 41.8629 136.5 75C136.5 108.137 109.637 135 76.5 135C43.3629 135 16.5 108.137 16.5 75Z",
    fill: "#F8696E"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5848_117409)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M42 102V67.4951L73.4766 88.8493L76 90.4118L78.3906 88.8493L110 67.4951V102H42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 54H110V64.4167L76 87.3333L42 64.4167V54Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5848_117409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.029 110C100.639 110 95.7168 107.188 93.0215 102.5C90.3262 97.8711 90.3262 92.1875 93.0215 87.5C95.7168 82.8711 100.639 80 106.029 80C111.361 80 116.283 82.8711 118.979 87.5C121.674 92.1875 121.674 97.8711 118.979 102.5C116.283 107.188 111.361 110 106.029 110ZM107.436 87.5H104.623V88.9062V95.4688V96.875H107.436V95.4688V88.9062V87.5ZM104.623 101.562H107.436V98.75H104.623V101.562Z",
    fill: "url(#paint0_linear_5848_117409)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5848_117409",
    x: 18,
    y: 38,
    width: 116,
    height: 96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.924056 0 0 0 0 0.224592 0 0 0 0 0.249049 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5848_117409"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5848_117409",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5848_117409",
    x: 67,
    y: 64,
    width: 78,
    height: 78,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.924056 0 0 0 0 0.224592 0 0 0 0 0.249049 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5848_117409"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5848_117409",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5848_117409",
    x1: 106,
    y1: 80,
    x2: 106,
    y2: 110,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDBDB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5848_117409"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 75C16.5 41.8629 43.3629 15 76.5 15C109.637 15 136.5 41.8629 136.5 75C136.5 108.137 109.637 135 76.5 135C43.3629 135 16.5 108.137 16.5 75Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgNoticeEmail);
export default __webpack_public_path__ + "static/media/img_notice_email.2af97c584bca78fced0cddbf53570ac1.svg";
export { ForwardRef as ReactComponent };